import clsx from "clsx";
import { ChangeEvent, FC, ReactNode, memo } from "react";

interface Props {
  id?: string;
  onClick?: () => void;
  label: string | ReactNode;
  checked?: boolean;
  containerClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  value?: string | number;
  onChange: (value: string | number | undefined) => void;
}

const CheckboxCardBase: FC<Props> = ({
  id,
  onClick,
  label,
  checked,
  containerClassName,
  labelClassName,
  disabled,
  value,
  onChange,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement> | undefined) => {
    onChange?.(event?.target?.value);
  };
  const classBase =
    "flex items-center border rounded-[4px] cursor-pointer px-[14px] py-[11px] hover:border-[#3ABCA8] cursor-pointer break-word";

  const statusClass = checked
    ? "bg-[#ECFAF7] border-[#3ABCA8]"
    : "border-[#DFDFE2]";

  const labelClassNames = [
    labelClassName,
    "cursor-pointer ml-2 pointer-events-none w-full text-base leading-[16px] break-word",
    disabled ? "text-theme-medium !cursor-default" : "text-theme",
  ].join(" ");

  return (
    <label
      className={clsx(classBase, statusClass, containerClassName, {
        "hover:border-[#DFDFE2] bg-[#F7F7F7] opacity-60 !cursor-default":
          disabled,
      })}
      htmlFor={id}
    >
      <input
        className={clsx("input-checkbox", {
          "!cursor-default": disabled,
        })}
        defaultChecked={checked}
        checked={checked}
        onClick={(e) => {
          onClick && onClick();
          e.stopPropagation();
        }}
        onChange={handleChange}
        type="checkbox"
        id={id}
        disabled={disabled}
        value={value}
        style={{
          backgroundPositionX: "5px",
        }}
      />
      <label className={labelClassNames} htmlFor={id}>
        {label}
      </label>
    </label>
  );
};

export const CheckboxCardType = memo(CheckboxCardBase);
